<template>
    <page title="performanceTitle" :help="help">
        <template #pageContainer>
            <v-row>
                <v-col
                    cols="12"
                    md="12" class="py-1">
                    <v-card>
                        <v-data-table
                            :headers="headers"
                            :items="Entities"
                            item-key="id"
                            class="elevation-1"
                            :items-per-page="10"
                            :loading="loading"
                            :loading-text="$t('text.performanceLoading')"
                            :server-items-length="Entities.length"
                            hide-default-footer
							:height="WindowSize.y - 470"
                            fixed-header>
                            <template #top>
                                <v-container class="mt-0 pt-0 pb-0 mb-0">
                                    <v-row>
										<v-col cols="12" sm="12" lg="2">
											<v-btn-toggle dense color="primary">
												<v-btn
													class="new-performance"
													color="primary"
													@click="newPerformance">
													<span class="hidden-sm-and-down">
														{{ $t(`text.newPerformance`) }}
													</span>
													<v-icon color="white">
														add
													</v-icon>
												</v-btn>
											</v-btn-toggle>
                                        </v-col>
                                        <v-col cols="12" sm="12" lg="2">
                                            <v-autocomplete outlined dense
												hide-details="auto"
                                                class="mt-0 pt-0"
                                                v-model="tempQP.performanceListId"
                                                :items="performanceLists"
												:disabled="!hasPerfLists"
                                                :label="$t('text.bestlist')"
                                                :loading="performanceListLoading"
												@change="onPerfromanceListChange"
                                                @keyup.enter.native="filter">
                                            </v-autocomplete>
                                        </v-col>
                                        <v-col cols="12" sm="12" lg="2">
                                            <v-autocomplete outlined dense
												hide-details="auto"
                                                class="mt-0 pt-0"
                                                v-model="tempQP.environment"
                                                :items="environment"
                                                :label="$t('text.environment')"
												@change="onEnvironmentChanged()"
                                                @keyup.enter.native="filter">
                                            </v-autocomplete>
                                        </v-col>
                                        <v-col cols="12" sm="12" lg="2">
                                            <v-autocomplete outlined dense
												hide-details="auto"
                                                class="mt-0 pt-0"
                                                v-model="tempQP.classCode"
                                                :items="classes"
												:disabled="!hasClasses"
                                                :label="$t('text.class')"
                                                :loading="classLoading"
												@change="onClassChanged()"
                                                @keyup.enter.native="filter">
                                            </v-autocomplete>
                                        </v-col>
                                        <v-col cols="12" sm="12" lg="2">
                                            <v-autocomplete outlined dense
												hide-details="auto"
                                                class="mt-0 pt-0"
                                                v-model="tempQP.eventCode"
                                                :items="events"
                                                :label="$t('text.event')"
												:disabled="!hasEvents"
                                                :loading="eventLoading"
                                                @keyup.enter.native="filter">
                                            </v-autocomplete>
                                        </v-col>
                                        <v-col cols="12" sm="12" lg="2" align="right">
                                            <v-btn-toggle
                                                dense
                                                color="secondary"
                                                justify="center"
                                                active-class="action-active">
                                                <v-btn
													:disabled="!isTempQueryParameterValid"
                                                    color="secondary"
                                                    @click="filter">
                                                    <span class="hidden-sm-and-down">
                                                        {{ $t(`text.filterButton`) }}
                                                    </span>
                                                    <v-icon color="white">
                                                        filter
                                                    </v-icon>
                                                </v-btn>
                                            </v-btn-toggle>
                                        </v-col>
                                    </v-row>
                                    <v-row>
										<v-col cols="12" sm="12" lg="4">
											<v-text-field outlined dense
												hide-details="auto"
												class="mt-0 pt-0"
												clearable
												:label="$t('text.search')"
												v-model="tempQP.freetextSearch">
											</v-text-field>
                                        </v-col>
										<v-col cols="12" sm="12" lg="2">
											<v-switch dense
												class="mt-0"
												hide-details="auto"
												v-model="tempQP.outputGrouping"
												:label="$t('text.bestPerfOnly')">
											</v-switch></v-col>
                                        <v-col cols="12" sm="12" lg="2">
                                            <v-menu
                                                v-model="menuFrom"
                                                :close-on-content-click="false"
                                                max-width="290">
                                                <template #activator="{ on }">
                                                    <v-text-field outlined dense
														hide-details="auto"
                                                        class="mt-0 pt-0"
                                                        :value="FormattedDateFrom"
                                                        clearable
                                                        :label="$t('text.dateFrom')"
                                                        readonly
                                                        v-on="on"
                                                        @click:clear="tempQP.dateFrom = null">
                                                    </v-text-field>
                                                </template>
                                                <v-date-picker
													locale="DE-de"
                                                    v-model="tempQP.dateFrom"
                                                    @change="menuFrom = false">
                                                </v-date-picker>
                                            </v-menu>
                                        </v-col>
                                        <v-col cols="12" sm="12" lg="2">
                                            <v-menu
                                                v-model="menuTo"
                                                :close-on-content-click="false"
                                                max-width="290">
                                                <template #activator="{ on }">
                                                    <v-text-field outlined dense
														hide-details="auto"
                                                        class="mt-0 pt-0"
                                                        :value="FormattedDateTo"
                                                        clearable
                                                        :label="$t('text.dateTo')"
                                                        readonly
                                                        v-on="on"
                                                        @click:clear="tempQP.dateTo = null">
                                                    </v-text-field>
                                                </template>
                                                <v-date-picker
													locale="DE-de"
                                                    v-model="tempQP.dateTo"
                                                    @change="menuTo = false">
                                                </v-date-picker>
                                            </v-menu>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </template>
                            <template #[`item.action`]="{ item }">
                                <v-tooltip bottom v-if="item.onePerfList">
                                    <template #activator="{ on }">
                                        <v-btn icon v-on="on"
                                            @click="decline(item.id, item.statusChecking, item.perfListId)">
                                            <v-icon v-if="item.statusChecking === checkingStatus.NotDecided">
                                                event_note
                                            </v-icon>
                                            <v-icon v-else>
                                                event_busy
                                            </v-icon>
                                        </v-btn>
                                        </template>
                                    <span v-if="item.status === checkingStatus.NotDecided">{{ $t(`text.notDecidedChecking`) }}</span>
                                    <span v-else>{{ $t(`text.negativeChecking`) }}</span>
                                </v-tooltip>
                                <v-tooltip bottom v-else>
                                    <template #activator="{ on }">
                                        <v-btn icon v-on="on"
                                            :disabled="item.noPerfList"
                                            @click="checkings(item.id)">
                                            <v-icon>
                                                remove_from_queue
                                            </v-icon>
                                        </v-btn>
                                        </template>
                                    <span>{{ $t(`text.declinePerf`) }}</span>
                                </v-tooltip>
                                <v-tooltip bottom v-if="item.creatorOrganisationId === Organization">
                                    <template #activator="{ on }">
                                        <v-btn icon v-on="on"
                                            @click="edit(item.id)">
                                            <v-icon>
                                                edit
                                            </v-icon>
                                        </v-btn>
                                        </template>
                                    <span>{{ $t(`text.edit`) }}</span>
                                </v-tooltip>
                                <v-tooltip bottom v-if="item.creatorOrganisationId === Organization">
                                    <template #activator="{ on }">
                                        <v-btn icon v-on="on"
                                            @click="deletePerf(item.id)">
                                            <v-icon>
                                                delete
                                            </v-icon>
                                        </v-btn>
                                        </template>
                                    <span>{{ $t(`text.delete`) }}</span>
                                </v-tooltip>
                            </template>
                            <template #[`item.statusLocalized`]="{ item }">
                                <v-chip :color="getStatusColor(item.status)" dark>
                                    {{ item.statusLocalized }}
                                </v-chip>
                            </template>
                            <template #[`item.performanceDateTime`]="{ item }">
                                {{ item.performanceDateTime | moment('DD.MM.YYYY') }}
                            </template>											
                        </v-data-table>
                        <pagination
                            :currentPage="Pagination.currentPage"
                            :totalPages="Pagination.totalPages"
                            :pageSize="queryParameters.pageSize"
                            @current="current"
                            @pageSizeChanged="pageSizeChanged">
                        </pagination>
                    </v-card>
                </v-col>
            </v-row>
        </template>
    </page>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';

import Page from '../general/Page.vue';
import Pagination from '../general/Pagination.vue';

import perfStatus from '../helpers/perfStatus';
import checkingStatus from '../helpers/checkingStatus';

import checkingActions from '../store/actions/checking';
import userActions from '../store/actions/user';

import performanceActions from '../store/actions/performance';
import bestListActions from '../store/actions/bestList';
import namespace from '../store/namespace';

class TempPerformanceQueryParameter {
	constructor(qp) {
		this.classCode = null;
		this.eventCode = null;

		if (qp !== undefined) {
			this.freetextSearch = qp.freetextSearch;
			this.outputGrouping = qp.outputGrouping;
			this.performanceListId = qp.performanceListId;
			this.environment = qp.environment;
			this.searchPeriod = qp.searchPeriod;
			this.classCode = qp.classCode;
			this.eventCode = qp.eventCode;
			this.dateFrom = qp.dateFrom;
			this.dateTo = qp.dateTo;
			this.freetextSearch = qp.freetextSearch;
		}
	}
}

class PerformanceQueryParameter {
	constructor(qp) {
		if (qp !== undefined) {
			this.freetextSearch = qp.freetextSearch;
			this.outputGrouping = qp.outputGrouping;
			this.performanceListId = qp.performanceListId;
			this.environment = qp.environment;
			this.searchPeriod = qp.searchPeriod;
			this.classCode = qp.classCode;
			this.eventCode = qp.eventCode;
			this.dateFrom = qp.dateFrom;
			this.dateTo = qp.dateTo;
			this.freetextSearch = qp.freetextSearch;
			this.pageNumber = qp.pageNumber;
			this.pageSize = qp.pageSize;
		} else {
			this.freetextSearch = '';
			this.outputGrouping = false;
			this.performanceListId = 0;
			this.environment = 0;
			this.searchPeriod = 0;
			this.classCode = 'M';
			this.eventCode = '100';
			this.dateFrom = null;
			this.dateTo = null;
			this.pageNumber = 1;
			this.pageSize = 10;
		}
	}

	updateTempData(qp) {
		this.freetextSearch = qp.freetextSearch;
		this.outputGrouping = qp.outputGrouping;
		this.performanceListId = qp.performanceListId;
		this.environment = qp.environment;
		this.searchPeriod = qp.searchPeriod;
		this.classCode = qp.classCode;
		this.eventCode = qp.eventCode;
		this.dateFrom = qp.dateFrom;
		this.dateTo = qp.dateTo;
		this.freetextSearch = qp.freetextSearch;
	}
}


export default {
	name: 'Performance',
	components: {
		Page,
		Pagination,
	},
	data() {
		return {
			headers: [
				{
					text: this.$i18n.t('text.headerActions'), align: 'left', value: 'action', sortable: false, width: 140,
				},
				{
					text: this.$i18n.t('text.headerStatus'), align: 'left', value: 'statusLocalized', sortable: false, width: 90,
				},
				{
					text: this.$i18n.t('text.headerBestResult'), align: 'left', value: 'bestResultString', sortable: false, width: 90,
				},
				{
					text: this.$i18n.t('text.headerBestWind'), align: 'left', value: 'bestWind', sortable: false, width: 50,
				},
				{
					text: this.$i18n.t('text.headerEventShortNational'), align: 'left', value: 'definitionEventShortNational', sortable: false, width: 100,
				},
				{
					text: this.$i18n.t('text.headerCompetitor'), align: 'left', value: 'fullName', sortable: false,
				},
				{
					text: this.$i18n.t('text.headerNation'), align: 'left', value: 'fullCompetitor.nation', sortable: false,
				},
				{
					text: this.$i18n.t('text.headerYob'), align: 'left', value: 'fullCompetitor.yob', sortable: false,
				},
				{
					text: this.$i18n.t('text.headerPerformanceOrganizationName'), align: 'left', value: 'performanceOrganizationName', sortable: false,
				},
				{
					text: this.$i18n.t('text.headerPerformanceDateTime'), align: 'left', value: 'performanceDateTime', sortable: false, width: 100,
				},
				{
					text: this.$i18n.t('text.headerPerformanceCompetitionName'), align: 'left', value: 'performanceCompetitionName', sortable: false,
				},
				{
					text: this.$i18n.t('text.headerPerformanceCompetitionTown'), align: 'left', value: 'performanceCompetitionTown', sortable: false, width: 100,
				},
				{
					text: this.$i18n.t('text.headerPerformanceCreatorUser'), align: 'left', value: 'creatorUser', sortable: false, width: 100,
				},
			],
			loading: false,
			eventLoading: false,
			classLoading: false,
			performanceListLoading: false,
			menuFrom: false,
			menuTo: false,
			events: [],
			classes: [],
			performanceLists: [],
			environment: [{ text: this.$i18n.t('text.indoor'), value: 0 }, { text: this.$i18n.t('text.outdoor'), value: 1 }, { text: this.$i18n.t('text.all'), value: 2 }],
			searchPeriod: [{ text: this.$i18n.t('text.perfTime'), value: 0 }, { text: this.$i18n.t('text.createTime'), value: 1 }, { text: this.$i18n.t('text.editTime'), value: 2 }],
			queryParameters: new PerformanceQueryParameter(),
			tempQP: new TempPerformanceQueryParameter(),
			help: [{
				icon: 'event_note',
				text: this.$t('text.notDecidedChecking'),
			}, {
				icon: 'event_busy',
				text: this.$t('text.negativeChecking'),
			}, {
				icon: 'remove_from_queue',
				text: this.$t('text.declinePerf'),
			}, {
				icon: 'delete',
				text: this.$t('text.delete'),
			},
			{
				icon: 'edit',
				text: this.$t('text.edit'),
			}],
		};
	},
	async mounted() {
		if (localStorage.getItem('performancesApp')) {
			this.queryParameters = new PerformanceQueryParameter(JSON.parse(localStorage.getItem('performancesApp')));
			this.tempQP = new TempPerformanceQueryParameter(this.queryParameters);
		} else {
			localStorage.setItem('performancesApp', JSON.stringify(this.queryParameters));
		}
		if (this.Links.length == 0) await this.getPerformanceLinks();
		await this.getPerformanceLists();
		await this.getClasses();
		await this.getEvents();
		if (this.queryParameters.performanceListId && this.queryParameters.eventCode && this.queryParameters.classCode) {
			this.loadData();
		}
	},
	watch: {
		queryParameters: {
			deep: true,
			handler() {
				localStorage.setItem('performancesApp', JSON.stringify(this.queryParameters));
			},
		},
	},
	computed: {
		...mapGetters(['WindowSize']),
		...mapGetters(namespace.ORGANIZATION, ['Organization', 'ExternalId']),
		...mapGetters(namespace.USER, ['User']),
		...mapGetters(namespace.PERFORMANCE, ['Links', 'Entities', 'Pagination']),
		isTempQueryParameterValid() {
			return !!(this.hasPerfLists && this.tempQP.eventCode && this.tempQP.classCode);
		},
		nonContentPage() {
			return this.Entities.length == 0;
		},
		FormattedDateFrom() {
			return this.tempQP.dateFrom
				? this.$moment(this.tempQP.dateFrom).format('DD.MM.YYYY')
				: '';
		},
		hasPerfLists() {
			return this.performanceLists.length != 0;
		},
		isListSelected() {
			return !!this.tempQP.performanceListId;
		},
		hasEvents() {
			return this.events.length != 0;
		},
		isEventSelected() {
			return !!this.tempQP.eventCode;
		},
		hasClasses() {
			return this.classes.length != 0;
		},
		isClassSelected() {
			return !!this.tempQP.classCode;
		},
		FormattedDateTo() {
			return this.tempQP.dateTo
				? this.$moment(this.tempQP.dateTo).format('DD.MM.YYYY')
				: '';
		},
		checkingStatus() {
			return checkingStatus;
		},
		getClassId() {
			return (this.classes.find(x => x.value == this.tempQP.classCode)).id;
		},
	},
	methods: {
		...mapMutations(namespace.PERFORMANCE, [
			performanceActions.REMOVE_GRID_DATA,
		]),
		...mapActions(namespace.PERFORMANCE, [
			performanceActions.GET_FILTERED_PERFORMANCE,
			performanceActions.GET_PERFORMANCE_LINKS,
			performanceActions.GET_CLASS_BY_PERF_ID,
			performanceActions.GET_EVENT_BY_PERF_ID,
			performanceActions.DELETE_PERF]),
		...mapActions(namespace.BESTLIST, [
			bestListActions.GET_BEST_LISTS_FOR_SELECTOR]),
		...mapActions(namespace.CHECKING, [
			checkingActions.UPDATE_CHECKING]),
		...mapActions(namespace.USER, [
			userActions.GET_USER,
		]),
		async loadData() {
			this.loading = true;
			try {
				if (this.hasPerfLists && this.hasEvents && this.hasClasses) {
					const perfRequest = {
						queryParameters: this.queryParameters,
					};

					await this.GET_FILTERED_PERFORMANCE(perfRequest);
					
					for (const entity of this.Entities) {
						if (entity.creatorUserId == '12345678-1234-1234-1234-123456789012')
						{
							entity.creatorUser = "External Import";
						}
						else if (entity.creatorUserId == null || entity.creatorUserId == undefined)
						{
							entity.creatorUser = "Automatic Import";
						}
						else
						{
							var user = await this.GET_USER(entity.creatorUserId);
							if (user != null)
							{
								entity.creatorUser = user.userName;
							}
							else
							{
								entity.creatorUser = "Unknown user";
							}
						}
					}

					if (this.nonContentPage) {
						this.queryParameters.pageNumber = this.Pagination.totalPages;
					}
				}
			} finally {
				this.loading = false;
			}
		},
		async getPerformanceLinks() {
			try {
				await this.GET_PERFORMANCE_LINKS();
			} catch (ex) {
				console.log(ex);
			}
		},
		async getPerformanceLists() {
			this.performanceListLoading = true;
			try {
				this.performanceLists = await this.GET_BEST_LISTS_FOR_SELECTOR(this.ExternalId);
				if (this.performanceLists.length != 0 && (this.tempQP.performanceListId == 0 || this.performanceLists.findIndex(x => x.value == this.tempQP.performanceListId) == -1)) {
					this.tempQP.performanceListId = this.performanceLists[0].value;
				}
			} finally {
				this.performanceListLoading = false;
			}
		},
		async onEnvironmentChanged() {
			this.tempQP.eventCode = null;
			await this.getEvents();
		},
		async onClassChanged() {
			this.tempQP.eventCode = null;
			await this.getEvents();
		},
		async edit(id) {
			this.$router.push({
				name: 'updateperformance',
				params: {
					id,
				},
			});
		},
		async deletePerf(id) {
			// eslint-disable-next-line no-alert
			const r = window.confirm(this.$i18n.t('text.deleteRequest'));
			if (r === true) {
				try {
					const link = this.Links.find(x => x.rel === 'delete_perf');
					if (link) {
						const href = link.href
							.replace('{id}', id);
						await this.DELETE_PERF({ href });
						this.filter();
					}
				} catch (ex) {
					console.log(ex);
				}
			}
		},
		newPerformance() {
			this.$router.push({
				name: 'newperformance',
				params: {
					eventCode: this.tempQP.eventCode,
					classCode: this.tempQP.classCode ? this.tempQP.classCode.value : '',
				},
			});
		},
		checkings(id) {
			this.$router.push({
				name: 'checking',
				params: {
					id,
				},
			});
		},
		async decline(id, status, perfListId) {
			const item = {
				status,
				reason: '',
				perfId: id,
				perfListId,
				userId: this.User.id,
			};

			this.loading = true;
			try {
				await this.UPDATE_CHECKING(item);

				await this.loadData();
			} finally {
				this.loading = false;
			}
		},
		getStatusColor(status) {
			switch (status) {
			case perfStatus.NothingDeclined: return 'green';
			case perfStatus.PartialDeclined: return 'orange';
			case perfStatus.FullyDeclined: return 'red';
			default: return 'white';
			}
		},
		async getEvents() {
			if (this.hasClasses) {
				this.eventLoading = true;
				try {
					const link = this.Links.find(x => x.rel === 'get_event_by_perf_id');
					if (link && this.tempQP.performanceListId && this.tempQP.classCode) {
						const href = link.href
							.replace('{perflist}', this.tempQP.performanceListId)
							.replace('{classId}', this.getClassId)
							.replace('{env}', this.tempQP.environment);
						this.events = await this.GET_EVENT_BY_PERF_ID({ href });
						if (this.events && this.events.length == 1) {
							this.tempQP.eventCode = this.events[0].value;
						} else if (this.events && this.events.findIndex(e => e.value === this.tempQP.eventCode) === -1) {
							this.tempQP.eventCode = null;
						}
					}
				} finally {
					this.eventLoading = false;
				}
			}
		},
		async getClasses() {
			if (this.hasPerfLists) {
				this.classLoading = true;
				try {
					const link = this.Links.find(x => x.rel === 'get_class_by_perf_id');
					if (link && this.tempQP.performanceListId) {
						const href = link.href.replace('{perflist}', this.tempQP.performanceListId);
						this.classes = await this.GET_CLASS_BY_PERF_ID({ href });
						// eslint-disable-next-line prefer-destructuring
						if (this.classes && this.classes.length == 1) {
							this.tempQP.classCode = this.classes[0].value;
						} else if (this.classes && this.classes.findIndex(e => e.value === this.tempQP.classCode) === -1) {
							this.tempQP.classCode = null;
						}
					}
				} finally {
					this.classLoading = false;
				}
			}
		},
		async filter() {
			this.queryParameters.updateTempData(this.tempQP);
			await this.loadData();
		},
		async pageSizeChanged(newPageSize) {
			const maxPage = Math.ceil(this.Pagination.totalCount / newPageSize);
			this.queryParameters.pageNumber = maxPage < this.Pagination.currentPage ? maxPage : this.Pagination.currentPage;
			this.queryParameters.pageSize = newPageSize;
			await this.loadData();
		},
		async current(newPage) {
			this.queryParameters.pageNumber = newPage;
			await this.loadData();
		},
		async update(item) {
			this.loading = true;
			try {
				await this.UPDATE_PERF(item);

				await this.loadData();
			} finally {
				this.loading = false;
			}
		},
		async onPerfromanceListChange() {
			this.REMOVE_GRID_DATA();
			this.classes = [];
			this.events = [];
			this.tempQP.classCode = null;
			this.tempQP.eventCode = null;
			await this.getClasses();
			await this.getEvents();
			if (this.isListSelected && this.isEventSelected && this.isClassSelected) {
				this.loadData();
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.new-performance {
    span {
        font-size: .675rem !important;
    }
}

.action-active {
    border-color: rgba(0,0,0,.12) !important;
    color: rgb(255, 255, 255) !important;
    opacity: 0.8 !important;

    &:before {
        opacity: 0 !important;
    }
}

.buton-row {
	padding-left:12px;
}
</style>
